<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
// import { commissionService } from "../../../services/saleservice/commission.service";
// import { commissionstatusService } from "../../../services/saleservice/commissionstatus.service";
// import { sellerService } from "../../../services/saleservice/seller.service";
import { propertyhandoverService } from "../../../services/propertyservice/propertyhandover.service";
import { servicehelpers } from "../../../services/servicehelpers";
import List from "../../../components/list";
import i18n from "../../../i18n";
/* eslint-disable no-console */
/**
 * Contacts-list component
 */
export default {
  page: {
    title: "Handover List",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader, List },
  data() {
    return {
      handoverData: {},
      statusData: {},
      saleData: {},
      propertyData: {},
      fetchingStats: false,
      title: "Handover List",

    };
  },
  mounted() {
    this.loadingStatusData();
    this.loadingData();
  },

  methods: {
    loadingData: function(param = '') {
      this.fetchingStats = false;
      propertyhandoverService.getList(param)
        .then(response => {
          
          this.fetchingStats = true;
          this.handoverData = response;
        });
    },

    loadingStatusData: function() {
      servicehelpers.getPropertyHandoverStatusData('')
        .then(response => {
          this.statusData = response;

        });
    },

    deleted: function(id) {
      propertyhandoverService.remove(id)
        .then(response => {
        
          // this.commissionData = response;
          if(response.status == 200) {
            this.$swal.fire({
              title: i18n.t('general.confirm.deleted'),
              text: i18n.t('general.confirm.success'),
              icon: "success",
              confirmButtonText: i18n.t('general.ok')
            });
          }
        });
    },

    pageNavigate: function(param) {
      this.loadingData(param);
    },

    submitAdd: function() {
      this.$router.push(this.$route.query.redirectFrom || {
              name: "customer-add",
          });
    },

    moreClick: function(event, id) {

      if(event == 'approve') {
        this.$swal.fire({
          title: i18n.t('general.cancel-confirm.title'),
          text: i18n.t('commission.finish-message'),
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#34c38f",
          cancelButtonColor: "#f46a6a",
          confirmButtonText: i18n.t('general.ok'),
          cancelButtonText: i18n.t('general.cancel')
        }).then(result => {
          if (result.value) {
            propertyhandoverService.approved(id).then(response => {
              if(response.status == 200){
                this.loadingData();
              }
            });
            console.log(id);
          }
        });
      } else if(event == 'denie') {
        this.$swal.fire({
          title: i18n.t('general.cancel-confirm.title'),
          text: i18n.t('commission.finish-message'),
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#34c38f",
          cancelButtonColor: "#f46a6a",
          confirmButtonText: i18n.t('general.ok'),
          cancelButtonText: i18n.t('general.cancel')
        }).then(result => {
          if (result.value) {
            propertyhandoverService.dennied(id).then(response => {
              if(response.status == 200){
                this.loadingData();
              }
            });
            console.log(id);
          }
        });
      }
    },

  }
};
</script>

<template>
  <Layout>
    <PageHeader :add="{icon: 'bx bx-add-to-queue bx-tada', title: 'general.new', link: ''}" :title="$t('property.handover.text')" />
    <List v-bind:dataList="handoverData" 
          v-bind:updating="fetchingStats" 
          v-bind:navigate="pageNavigate"
          v-bind:formats="[{name: 'sale_price', type: 'currency', sign: '$'}, {name: 'handover_date', type: 'date'}, {name: 'status', color: true}]"
          v-bind:fields="[ `property: ${$t('property.text')}`, `sale: ${$t('sale.text')}`, 
            `sale_price: ${$t('general.sale_price')}`, `notation: ${$t('general.notation')}`, 
            `handover_date: ${$t('general.date')}`, `status: ${$t('property.status')}`
          ]" 
          @more="moreClick"
          v-bind:more="{
            sub: [{
              name: 'property.cancelation.approve', icon: 'bx bx-check-circle', action: 'approve', link: 'commission-paid', column: 'id', show: {column: 'property_handover_status_id', value: 1}
            },{
              name: 'property.cancelation.denie', icon: 'bx bx-x-circle', action: 'denie', link: 'commission-paid', column: 'id', show: {column: 'property_handover_status_id', value: 1}
            },{
              name: 'invoice.print', icon: 'bx bx-printer', link: 'commission-print', column: 'id', target: '_blank'
            }] 
          }"
          v-bind:filter="{
            search: ['commissions.code', 'commissions.name', 'properties.code'],
            dropdown: [],
            date: {
              title: 'general.date',
              field: 'commissions.created_by'
            }
          }"
          
    />      
  </Layout>
</template>